import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {connect} from 'react-redux';

import {isNoU} from 'utils/DBUtils';

const mapStateToProps = (state) => {
  return {
    isAuthenticated: (!isNoU(state.user) && !isNoU(state.user.accessToken))
  };
}

const PrivateRoute = ({ component: Component, isAuthenticated, ...rest }) => {
  return (
    <Route {...rest} render={(props) => isAuthenticated === true
        ? <Component {...props} />
        : <Redirect to={{pathname: '/login',  state: { from: props.location } // pass url user was trying to access to bring them back there
        }} />
    } />)
}

export default connect(mapStateToProps, null, null, {pure: false})(PrivateRoute);
/*https://stackoverflow.com/questions/43520498/react-router-private-routes-redirect-not-working*/



// WEBPACK FOOTER //
// ./public/components/common/PrivateRoute.jsx